import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CurrencyContext = createContext(null);

const DEFAULT_CURRENCIES = [
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', rate_to_usd: 1.0 }
];

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    const saved = localStorage.getItem('medlab_currency');
    return saved || 'NGN';
  });
  const [currencies, setCurrencies] = useState(DEFAULT_CURRENCIES);

  useEffect(() => {
    localStorage.setItem('medlab_currency', currency);
  }, [currency]);

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get(`${API}/currencies`);
      setCurrencies(response.data);
    } catch (error) {
      console.error('Failed to fetch currencies:', error);
    }
  };

  const getCurrencyInfo = (code) => {
    return currencies.find(c => c.code === code) || currencies[0];
  };

  const formatPrice = (amount, currencyCode = currency) => {
    const info = getCurrencyInfo(currencyCode);
    return `${info.symbol}${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const value = {
    currency,
    setCurrency,
    currencies,
    getCurrencyInfo,
    formatPrice,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
